import { FC, useEffect } from 'react';
import { useAuthContext } from '@/context/AuthContext.tsx';
import { Outlet } from 'react-router-dom';
import Middleware from '@/router/middleware/index.tsx';
import { passToRouteSearchParams } from '@/utils/passToRouteSearchParams.ts';
import SearchParams from '@/_constants/SearchParams.ts';

const HasSubscription: FC = () => {
  const { isLoading, user } = useAuthContext();

  const hasSubscription = !!user?.is_subscription_active;

  useEffect(() => {
    const redirectUrl = new URL(window.location.href);

    if (!isLoading && !hasSubscription) {
      window.location.href = passToRouteSearchParams(`${import.meta.env.VITE_FRONTEND_URL}/payment-select`, {
        [SearchParams.REDIRECT_URL]: encodeURIComponent(redirectUrl.toString()),
      });
    }
  }, [isLoading, hasSubscription]);

  return <Middleware isLoading={isLoading}>{hasSubscription ? <Outlet /> : null}</Middleware>;
};

export default HasSubscription;
